<div class="yelow-box p-3 text-center">
  <div>
    <i>
      A 6 digit verification code has been @if (resent) {
      <span>re</span>
      }sent to <b>{{selectedProvider!.text}}</b>
      <br>
        @if (altProvider?.text) {
          To send your code to <b>{{altProvider!.text}}</b> instead, click <a href="javascript:void(0)" (click)="resend(altProvider!)">here</a>.
        }
      </i>
    </div>
    <div class="form-group py-3">
      <div class="row">
        <div class="col-md-5 text-md-right">
          6 Digit Verification Code:<br>
          <small><a href="javascript:void(0)" (click)="codeSlider=true">Didn't get verification code?</a></small>
        </div>
        <div class="col-md-5 col-11 text-nowrap">
          <pincode-input (pcChange)="codeChange($event)" />
          <i tabindex="0" class="i m-1" (click)="helpSlider=true"></i>
        </div>
      </div>
    </div>
    @if (errorMsg && code==='') {
      <div class="alert-danger text-center p-2 mb-3">
        @if (errorAttempts) {
          <p>
            Unfortunately, that 6 digit verification password is incorrect or has expired.<br/>
            @if (selectedProvider!.type !== 'phone') {
              <span><b>Please reenter the code you received at {{selectedProvider!.text}}.</b> To Resend,</span>
            }
            @if (selectedProvider!.type === 'phone') {
              <span><b>Please refer to your mobile {{selectedProvider!.text}}.</b> Or for other options,</span>
            }
            click <a href="javascript:void(0)" (click)="codeSlider=true">here</a>
          </p>
        }
        <p>{{errorMsg}}</p>
      </div>
    }
    @if (isLogin) {
      <div class="text-center text-nowrap pb-2">
        <button class="grey-button mr-md-5 mr-3 skip2fa b2fa" type="button" id="SkipLogin" [disabled]="!codeValid" (click)="handleRememberMe()">
          LOGIN and <b>SKIP</b><br>
          this additional security step next time
        </button>
        <button class="grey-button b2fa" type="submit" id="VerifyLogin" [disabled]="!codeValid" (click)="handleRememberMeNot()">
          LOGIN and <b>KEEP</b><br>
          this additional security step next time
        </button>
      </div>
      @if (codeValid) {
        <div class="text-alert text-center">
          Privacy Warning : Skipping this verification code step is NOT recommended if you are using a public computer or a shared device
        </div>
      }
    }

    @if (!isLogin) {
      <button class="btn btn-NWM" type="button" [disabled]="!codeValid" (click)="verifyCode()">Submit</button>
    }

  </div>

  <div [ngClass]="{hidden:!helpSlider}" class="help-slider">
    <div class="slider-content">
      <i tabindex="0" class="fa fa-close" (click)="helpSlider=false"></i>
      This 6 digit verification code is an added layer of security designed to<br/>
      authenticate you. The unique code is sent to devices and email accounts to <br/>
      which only you should have access<br/>
    </div>
  </div>

  <div [ngClass]="{hidden:!codeSlider}" class="code-slider">
    <div class="codeslider-content">
      <i tabindex="0" class="fa fa-close" (click)="codeSlider = false"></i>
      @if (selectedProvider!.type === 'phone') {
        A 6 digit verification code has been sent to your phone <b> {{selectedProvider!.text}}</b> via text
        message. This verification code is valid for the next 15 minutes. If you do not receive a text
        message within 15 minutes from submitting, please try one of the following options:
      }
      @if (selectedProvider!.type === 'email') {
        A 6 digit verification code has been sent to your email<b> {{selectedProvider!.text}}.</b>
        <br /> This verification code is valid for the next 15 minutes.
        <strong>Please check both your Inbox and Junk Folder</strong>
        for an email from clientservices&#64;nicolawealth.com. If you do not
        receive an email within 15 minutes from submitting, please try resend below:
      }

      <div class="row mt-3 codeslider-buttons">
        <div class="col-6">
          @if (hasPhoneOption===true) {
            <button class="btn btn-NWM w-100 h-auto" (click)="resend(selectedProvider!.type === 'phone' ? selectedProvider! : altProvider!)">Resend Text<br/>{{selectedProvider!.type === 'phone' ? selectedProvider!.text : altProvider!.text }}</button>
          }
          @if (hasPhoneOption!==true) {
            <button class="btn btn-NWM w-100 h-auto" disabled>Resend Text-NA<br/>(No Mobile Setup)</button>
          }
        </div>
        <div class="col-6">
          <button class="btn btn-NWM w-100 h-auto" (click)="resend(selectedProvider!.type === 'email' ? selectedProvider! : altProvider!)">Resend Email<br/>{{selectedProvider!.type === 'email' ? selectedProvider!.text : altProvider!.text }}</button>
        </div>
      </div>
    </div>
  </div>
